<template>
  <el-dialog :visible.sync="visible" :show-close="true" :close-on-click-modal="false" :fullscreen="true"
    :append-to-body="true" @opened="onOpen" :before-close="beforeClose">
    <div class="choose-route-driver-container" v-show="visible">
      <!-- 地图区域：固定容器 ID，复用同一地图实例，避免反复 create/destroy 导致高德内部对象泄漏 -->
      <div id="chooseRouteDriverMap" class="map-container"></div>

      <!-- 司机列表区域 -->
      <div class="driver-list-container">
        <div class="driver-list-header">
          <span>
            <span class="title">合适司机列表 ({{ driverList.length }})</span>
            <el-checkbox v-model="mustBack" style="margin-left: 10px">必须返回</el-checkbox>
            <el-checkbox v-model="showDepartAdjust" style="margin-left: 10px">显示排名原因</el-checkbox>
          </span>

          <el-button size="small" @click="refreshData">刷新</el-button>
        </div>
        <div class="driver-list-content">
          <el-table :data="driverList" size="mini" stripe border
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" v-loading="loading"
            @row-click="highlightDriver" highlight-current-row :row-class-name="driverRowClass">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>

            <el-table-column prop="driverNo" label="司机编号" width="110" align="center">
              <template slot-scope="scope">
                <span class="driver-no-cell">
                  <span v-if="scope.row.newer" class="newbie-tag">新</span>
                  <span class="driver-no">{{ scope.row.driverNo }}</span>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="driverName" label="司机姓名" width="100" align="center">
            </el-table-column>

            <el-table-column prop="leftSeats" label="车辆" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.yueyangCar ? "岳阳" : "" }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column prop="seats" label="座位数" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.seats }}座</span>
              </template>
            </el-table-column> -->

            <el-table-column prop="leftSeats" label="当前状态" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.status | enumTransfer(schedulingStatus) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="lastFinishTime" sortable label="最近完单时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.lastFinishTime | dateFormat("MM月dd日 hh:mm:ss") }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="leftSeats" label="已发" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.tripTimes }}次/{{
                  (scope.row.routePoints / 100).toFixed(1)
                }}分</span>
              </template>
            </el-table-column>

            <el-table-column prop="monthRoutePoints" :sortable="true" label="积分" align="center"
              :sort-method="(a, b) => Number(a.monthRoutePoints) - Number(b.monthRoutePoints)">
              <template slot-scope="scope">
                <span>{{ scope.row.monthRoutePoints }}/{{ scope.row.basePoints }}积分</span>
              </template>
            </el-table-column>

            <el-table-column label="轮换" width="220" align="left">
              <template slot-scope="scope">
                <div class="shift-brief">连夜{{ scope.row.continuousNightDay || 0 }} 连晚{{
                  scope.row.continuousBackTooLateDay || 0 }} 连早{{ scope.row.continuousMorningDay || 0 }}</div>
                <div class="shift-brief">月夜{{ scope.row.nightDays || 0 }} 月晚{{ scope.row.totalBackTooLateDay || 0
                }} 月早{{ scope.row.totalMorningDay || 0 }}</div>
                <div v-if="showDepartAdjust && scope.row.departAdjust" class="depart-adjust">{{ scope.row.departAdjust
                  }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="emptyRun" label="放空" width="140" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.emptyPathId || scope.row.emptyRun">
                  <span class="empty-run-tag">需放空</span>
                  <div class="empty-run-path">{{ scope.row.emptyRun }}</div>
                </template>
              </template>
            </el-table-column>

            <el-table-column prop="realEarliestArriveTime" sortable label="最快可接时间" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row.realEarliestArriveTime | dateFormat("MM月dd日 hh:mm:ss")
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="earliestArriveTime" sortable label="最早可接时间" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row.earliestArriveTime | dateFormat("MM月dd日 hh:mm:ss")
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="leftSeats" label="收车" align="center">
              <template slot-scope="scope">
                <span> {{ scope.row.leaveDays }}/{{ scope.row.maxLeaveDaysPerMonth }}休</span>
              </template>
            </el-table-column>

            <el-table-column prop="offTime" label="请假" :sortable="true" align="center" :sort-method="(a, b) => {
              // 如果都为空，等于
              if (!a.offTime && !b.offTime) return 0;
              // 为空的排后面
              if (!a.offTime) return 1;
              if (!b.offTime) return -1;
              // 字符串转时间进行比较
              return new Date(a.offTime).getTime() - new Date(b.offTime).getTime();
            }
              ">
              <template slot-scope="scope">
                <span v-if="scope.row.backTomorrow" class="green">明日销假</span>
                <span v-else>{{ scope.row.offTime | leaveFilter }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click.stop="dispatchDriver(scope.row)">
                  指派
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="!loading && driverList.length === 0" class="no-data">
            <p>暂无合适司机</p>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getSuitableDrivers, dispatchOrders } from "@/api/dispatch";
import { DateUtil } from "@/util";
import { mapState } from "vuex";
import { ORDER_CHANGE } from "@/core/const/global-event";

const startPng = require("@/assets/image/start.png");
const carPng = require("@/assets/image/car_blue.png");

export default {
  name: "ChooseRoutteDriver",
  filters: {
    baggagesRemarkFilter(val) {
      if (val) {
        return val.substr(1);
      }
      return val;
    },
    leaveFilter(offTime) {
      if (offTime) {
        return DateUtil.dateStrFormat(offTime, "MM-dd");
      }
      return "";
    },
    backTimeFilter(time) {
      if (time) {
        // 当前日期减1天
        return DateUtil.getSpecDayStr(time, -1, "MM-DD");
      }
      return "";
    }
  },

  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      schedulingStatus: (state) => state.enumMap["SCHEDULING_STATUS"]
    })
  },
  data() {
    return {
      visible: false,
      loading: false,
      orders: [],
      driverList: [],
      mustBack: false,
      showDepartAdjust: false
    };
  },
  created() {
    // 地图及 marker 不放入 data，避免被 Vue 响应式化（会递归给整棵地图对象加 Observer/Dep，导致关闭后无法释放）
    this.map = null;
    this.orderMarker = null;
    this.driverMarkers = [];
  },
  beforeDestroy() {
    this.clearOnClose(true);
  },
  methods: {
    driverRowClass({ row }) {
      if (row.cannotDepart) {
        return "cannot-depart";
      }
      if (row.emptyPathId || row.emptyRun) {
        return "need-empty-run";
      }
      return "";
    },

    show(orders) {
      this.orders = orders;
      this.driverList = [];
      this.visible = true;
    },

    onOpen() {
      if (!this.map) this.initMap();
      this.$nextTick(() => {
        this.map && this.map.resize();
      });
      this.loadDriverData();
    },

    async loadDriverData() {
      this.loading = true;
      try {
        const firstOrderId = this.orders[0].id;
        const res = await getSuitableDrivers(firstOrderId, this.mustBack);
        this.driverList = res.data || [];
        this.renderMap();
      } catch (error) {
        console.error("获取合适司机失败:", error);
        this.$message.error("没有获取到合适的司机");
      } finally {
        this.loading = false;
      }
    },

    initMap() {
      this.map = new AMap.Map("chooseRouteDriverMap", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14
      });
    },

    renderMap() {
      // 先清除地图上已有覆盖物，避免多次刷新时重复叠加 marker 导致内存持续增长
      if (this.map) {
        this.map.clearMap();
      }

      const markers = [];

      this.orders.forEach((item, index) => {
        const { depLongitude, depLatitude, departure } = item;

        const pre = index == 0 ? "首位：" : "";
        // 创建订单起点标记
        const depMarker = new AMap.Marker({
          position: [depLongitude, depLatitude],
          icon: new AMap.Icon({
            image: startPng,
            size: new AMap.Size(40, 40),
            imageSize: new AMap.Size(40, 40)
          }),
          label: {
            direction: "top",
            content: "<div class='info'>" + pre + departure + "</div>"
          },
          draggable: true,
          raiseOnDrag: true
        });

        markers.push(depMarker);
      });

      const driverMarkers = [];

      this.driverList.forEach((item) => {
        const { lastLocation, driverNo } = item || {};
        if (lastLocation) {
          const { lng, lat } = lastLocation;
          const marker = new AMap.Marker({
            position: [lng, lat],
            draggable: true,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 40), //图标大小
              image: carPng,
              imageSize: new AMap.Size(40, 40)
            }),
            label: {
              direction: "top",
              content: "<div class='info'>" + driverNo + "</div>"
            },
            extData: { driverId: item.driverId, driverNo: item.driverNo }
          });
          markers.push(marker);
          driverMarkers.push(marker);
        }
      });

      this.driverMarkers = driverMarkers;
      this.map.add(markers);
      this.map.setFitView(markers);
    },

    highlightDriver(driver) {
      // 高亮显示选中的司机
      this.driverMarkers.forEach((marker) => {
        const extData = marker.getExtData();
        if (extData && extData.driverId === driver.driverId) {
          // 可以在这里添加高亮效果，比如改变图标或添加动画
          this.map.setCenter(marker.getPosition());
          marker.setOptions({
            label: {
              direction: "top",
              content: "<div class='red'>" + extData.driverNo + "</div>"
            }
          });
        } else {
          marker.setOptions({
            label: {
              direction: "top",
              content: "<div class='info'>" + extData.driverNo + "</div>"
            }
          });
        }
      });
    },

    locateDriver(driver) {
      const location = driver.location;
      if (!location || !location.lng || !location.lat) {
        this.$message.warning("该司机暂无位置信息");
        return;
      }

      this.map.setCenter([location.lng, location.lat]);
      this.map.setZoom(16);
      this.highlightDriver(driver);
    },

    refreshData() {
      this.loadDriverData();
    },

    /** 关闭时只清数据和覆盖物，不 destroy 地图，避免高德内部 (zooms/styles/road 等) 泄漏 */
    clearOnClose(destroyMap = false) {
      this.orders = [];
      this.driverList = [];
      this.driverMarkers = [];
      this.orderMarker = null;
      if (this.map) {
        this.map.clearMap();
        if (destroyMap) {
          this.map.destroy();
          this.map = null;
        }
      }
    },

    beforeClose(done) {
      this.clearOnClose(false);
      done && done();
    },

    dispatchDriver(driver) {
      const tip = driver.emptyPathId
        ? `将先创建放空行程「${driver.emptyRun || ""}」，再指派该司机，确定吗？`
        : "确定指派该司机吗？";
      const state = { ignoreAskLeave: false };
      const message = this.$createElement({
        data() {
          return { ignoreAskLeave: false };
        },
        render(h) {
          return h("div", [
            h("p", { style: { margin: "0 0 10px", lineHeight: "22px" } }, tip),
            h("el-checkbox", {
              props: { value: this.ignoreAskLeave },
              on: {
                input: (val) => {
                  this.ignoreAskLeave = val;
                  state.ignoreAskLeave = val;
                }
              }
            }, "忽略异常")
          ]);
        }
      });
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const param = {
          orderIds: this.orders.map((item) => item.id),
          routeId: null,
          ignoreAskLeave: state.ignoreAskLeave,
          driverId: driver.driverId,
          emptyPathId: driver.emptyPathId || null
        };

        dispatchOrders(param).then(() => {
          this.$message.success("指派司机成功");
          this.$bus.$emit(ORDER_CHANGE);
          this.clearOnClose(false);
          this.visible = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.empty-run-tag {
  display: inline-block;
  padding: 0 4px;
  line-height: 18px;
  font-size: 13px;
  color: #d46b08;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 2px;
}

.empty-run-path {
  margin-top: 2px;
  font-size: 13px;
  line-height: 18px;
  color: #d46b08;
}

.driver-no-cell {
  position: relative;
  display: inline-block;
}

.driver-no {
  display: inline-block;
  min-width: 4em;
  text-align: center;
}

.newbie-tag {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-right: 2px;
  transform: translateY(-50%);
  padding: 0 3px;
  line-height: 18px;
  font-size: 13px;
  color: #722ed1;
  background: #f9f0ff;
  border-radius: 2px;
}

.choose-route-driver-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 36px);
  overflow: hidden;
}

.map-container {
  flex: 0 0 30%;
  width: 100%;
  min-height: 180px;
  max-height: 280px;
  border: 1px solid #e0e0e0;
}

.driver-list-container {
  flex: 1;
  min-height: 0;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  background: #fff;

  .driver-list-header {
    padding: 4px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    background: #f5f7fa;

    .title {
      font-size: 15px;
      font-weight: bold;
      color: #333;
    }
  }

  .driver-list-content {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 4px 6px;

    .no-data {
      text-align: center;
      padding: 40px;
      color: #999;
    }

    .shift-brief {
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
    }

    .depart-adjust {
      color: #d46b08;
      font-size: 13px;
      line-height: 18px;
      white-space: normal;
    }
  }
}

/deep/ .driver-list-content .el-table {
  font-size: 13px;
}

/deep/ .driver-list-content .el-table td,
/deep/ .driver-list-content .el-table th {
  padding: 3px 0;
}

/deep/ .driver-list-content .el-table .cell {
  line-height: 18px;
  font-size: 13px;
  padding-left: 4px;
  padding-right: 4px;
}

/deep/ .driver-list-content .el-table .el-button--text {
  padding: 0;
}

/deep/ .el-table__body tr.cannot-depart>td,
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped.cannot-depart>td,
/deep/ .el-table__fixed-body-wrapper tr.cannot-depart>td {
  background-color: #fdecea;
}

/deep/ .el-table--enable-row-hover .el-table__body tr.cannot-depart:hover>td,
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped.cannot-depart:hover>td,
/deep/ .el-table__fixed-body-wrapper tr.cannot-depart:hover>td {
  background-color: #f8dede;
}

/deep/ .el-table__body tr.need-empty-run>td,
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped.need-empty-run>td,
/deep/ .el-table__fixed-body-wrapper tr.need-empty-run>td {
  background-color: #fff7e6;
}

/deep/ .el-table--enable-row-hover .el-table__body tr.need-empty-run:hover>td,
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped.need-empty-run:hover>td,
/deep/ .el-table__fixed-body-wrapper tr.need-empty-run:hover>td {
  background-color: #ffe7ba;
}

/deep/ .info {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 8px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 6px 0px;
  font-size: 12px;
  white-space: nowrap;
}

/deep/ .car-info {
  background-color: rgba(64, 158, 255, 0.8);
  color: white;
  padding: 5px 8px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 6px 0px;
  font-size: 12px;
  white-space: nowrap;
}

/deep/ .red {
  background-color: rgba(255, 0, 0, 0.8);
  color: white;
  padding: 5px 8px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 6px 0px;
  font-size: 12px;
  white-space: nowrap;
}

/deep/ .el-dialog__header {
  padding: 0;
}

/deep/ .el-dialog__headerbtn {
  top: 8px;
  right: 12px;
  z-index: 2;
}

/deep/ .el-dialog__body {
  padding: 4px 8px 6px;
}
</style>
